import { LogOut, User } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { getInitials } from '@/lib/helpers';

export function HeaderTopbar() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate('/logout');
  };

  return (
    <div className="flex items-center gap-3">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="cursor-pointer size-9 rounded-full justify-center border border-gray-500 shrink-0 hover:opacity-80 transition-opacity">
            <Avatar className="size-9">
              <AvatarFallback className="bg-primary text-primary-foreground">
                {getInitials(user?.name, 2)}
              </AvatarFallback>
            </Avatar>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" sideOffset={8}>
          <div className="px-2 py-1.5">
            <p className="text-sm font-medium">{user?.name || 'Usuário'}</p>
            <p className="text-xs text-muted-foreground">{user?.role || ''}</p>
          </div>
          <DropdownMenuItem onClick={handleLogout} className="cursor-pointer">
            <LogOut className="size-4" />
            Sair
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}

